module.exports = __webpack_public_path__ + "img/intro1_zh.ec199744.jpg";